import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white/10 backdrop-blur-sm border-t border-white/20 py-8">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-white/80 text-sm">
            © 2025 Todos os direitos reservados Kontty
          </p>
          <div className="flex space-x-6">
            <Link 
              to="/termos-de-servico" 
              className="text-white/80 hover:text-white text-sm transition-colors"
            >
              Termos de Serviço
            </Link>
            <Link 
              to="/politica-de-privacidade" 
              className="text-white/80 hover:text-white text-sm transition-colors"
            >
              Política de Privacidade
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}